import React, { useEffect, useState } from 'react';

import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material';

import CloseIcon from '~/assets/icons/CloseIcon';
import SearchIcon from '~/assets/icons/SearchIcon';
import { SMALL_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';

const SEARCH_DELAY = 500;
let timeout;

interface SearchInputProps {
  handleSearch: (val: string) => void;
  delay?: number;
  isFromSearch?: boolean;
  handleClear?: () => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  handleSearch,
  delay = SEARCH_DELAY,
  isFromSearch = false,
  handleClear,
}) => {
  const [searchVal, setSearchVal] = useState('');

  const onSearch = (e) => {
    clearTimeout(timeout);
    const val = e.target.value;
    setSearchVal(val);
    timeout = setTimeout(() => {
      handleSearch(val);
    }, delay);
  };

  const onClear = () => {
    setSearchVal('');
    handleClear && handleClear();
  };

  //clear search on outside search state change ,
  // algolia clear RefinementList search in this situation
  useEffect(() => {
    if (!isFromSearch) {
      setSearchVal('');
    }
  }, [isFromSearch]);

  return (
    <SearchWrapper>
      <Search type="input" value={searchVal} onChange={onSearch} />
      <StyledSearchIcon isPopulated={Boolean(searchVal)} />
      {searchVal && (
        <CloseIconWrapper aria-label="clear" onClick={onClear} size="large">
          <StyledCloseIcon />
        </CloseIconWrapper>
      )}
    </SearchWrapper>
  );
};

export default SearchInput;

const SearchWrapper = styled(Box)`
  position: relative;
`;
const Search = styled('input')`
  width: 100%;
  margin-bottom: ${SMALL_MARGIN_PX};
  padding: 10px;
  padding-left: 45px;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.common.white};
  background: ${({ theme }) => theme.palette.common.blockBackground.light};
  border-radius: 5px;
  border: none;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${({ theme }) => theme.palette.common.gray};
    transition: 0.2s color;
  }

  &:hover {
    box-shadow: ${({ theme }) => theme.palette.common.card.shadowValue};
  }

  &:hover::placeholder {
    color: ${({ theme }) => theme.palette.common.star};
  }

  &:hover + svg {
    color: ${({ theme }) => theme.isSsku && theme.palette.common.accent};
    opacity: ${({ theme }) => !theme.isSsku && 1};
  }
`;
const CloseIconWrapper = styled(IconButton)`
  position: absolute;
  right: 6px;
  top: 3px;
  padding: 9px;
`;
const StyledCloseIcon = styled(CloseIcon)`
  width: 14px;
  height: 14px;

  color: ${({ theme }) => theme.isSsku && theme.palette.common.accent};
`;
const StyledSearchIcon = styled(SearchIcon, {
  shouldForwardProp: (prop) => prop !== 'isPopulated',
})<{ isPopulated: boolean }>`
  position: absolute;
  top: calc(50% - ${TINY_MARGIN_PX});
  left: 15px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: ${({ theme, isPopulated }) => isPopulated && theme.palette.common.star};
  transition: 0.3s color opacity;
  opacity: ${({ theme, isPopulated }) => (theme.isSsku || isPopulated ? 1 : 0.2)};
`;
